<template>
    <div>

        <el-form :model="from" :rules="rules" ref="from" style="padding-left: 3%; padding-right: 8%;"
            label-width="100px">

            <el-row>
                <el-col :span="12">
                    <el-form-item label="用户名" prop="name">
                        <el-input v-model="from.name" placeholder="请输入用户名" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>

                <!-- <el-col :span="12">
                    <el-form-item label="密码" prop="pwd">
                        <el-input type="password" v-model="from.pwd" placeholder="请输入密码" style="width: 100%;">
                        </el-input>
                    </el-form-item>
                </el-col> -->
                <el-col :span="12">
                    <el-form-item label="角色" prop="role_id">
                        <el-select v-model="from.role_id" placeholder="请选择角色" style="width: 100%;" filterable>
                            <el-option v-for="item in $parent.$parent.roleList" :key="item.id"
                                :label="item.role_name" :value="item.id">
                            </el-option>
                        </el-select>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <div @click="StaffFind">
                        <el-form-item label="员工" prop="staff_id">
                            <!-- <el-select v-model="from.staff_id" placeholder="请选择员工" style="width: 100%;" filterable>
                                <el-option v-for="item in $parent.$parent.staffList" :key="item.id" :label="item.staff_name"
                                    :value="item.id">
                                </el-option>
                            </el-select> -->
                            <el-input style="width:100%" v-model="from.staff_name" onfocus="this.blur();"></el-input>
                        </el-form-item>
                    </div>
                </el-col>
                <el-dialog title="选择员工" :visible.sync="dialogVisibles" width="40%" :center="true" :close-on-click-modal="true"
                    :show-close="false" :modal-append-to-body="false" :append-to-body="true">
                    <el-row>
                        <organizeStaff ref="organizeStaff" type="radio" :accordion="false" @commit="saveChange"
                            :staff_id_prop="from.staff_id"></organizeStaff>
                    </el-row>
                    <el-row style="text-align: center;">
                        <el-button type="goon" style="margin-top: 10px;" @click="$refs['organizeStaff'].commit()">确定</el-button>
                    </el-row>
                </el-dialog>

                <el-col :span="12">
                    <el-form-item label="手机号" prop="phone">
                        <el-input v-model="from.phone" placeholder="请输入手机号" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-row>
                <el-col :span="12">
                    <el-form-item label="邮箱" prop="mailbox">
                        <el-input v-model="from.mailbox" placeholder="请输入邮箱" style="width: 100%;"></el-input>
                    </el-form-item>
                </el-col>
            </el-row>

            <el-form-item style="text-align: center;" label-width="0px">
                <el-button type="primary" @click="Add" v-if="from.id === null || from.id === ''"
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">保存</el-button>
                <el-button type="primary" @click="Modify" v-else
                    style="width: 30%; background-color: #006E4B; border: 1px solid #006E4B;">修改</el-button>
            </el-form-item>
        </el-form>

    </div>
</template>

<script>
    import organizeStaff from '../../utils/organizeStaff/organizeStaff.vue';
    import axios from "axios";
    export default {
        components: {
            organizeStaff: organizeStaff
        },
        data() {
            var checkPhone = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入手机号！'));
                } else {
                    const reg = /^1[3|4|5|7|8][0-9]\d{8}$/
                    console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else { 
                        return callback(new Error('手机号格式错误！'));
                    }
                }
            };
            var checkEMail = (rule, value, callback) => {
                if (!value) {
                    return callback(new Error('请输入邮箱！'));
                } else {
                    const reg =
                        /^[a-zA-Z0-9_-]+@[a-zA-Z0-9_-]+(\.[a-zA-Z0-9_-]+)+$/
                    console.log(reg.test(value));
                    if (reg.test(value)) {
                        callback();
                    } else {
                        return callback(new Error('邮箱格式错误！'));
                    }
                }
            };
            return {
                dialogVisibles:false,
                //表单数据
                from: {
                    id: "",
                    name: "",
                    // pwd: "",
                    role_id: "",
                    staff_id: "",
                    staff_name:"",
                    phone: "",
                    mailbox: "",
                },

                //表单验证
                rules: {
                    name: [{
                        required: true,
                        message: '请输入用户名！',
                        trigger: 'blur'
                    }],
                    // pwd: [{
                    //     required: true,
                    //     message: '请输入密码！',
                    //     trigger: 'blur'
                    // }],
                    role_id: [{
                        required: true,
                        message: '请选择角色！',
                        trigger: 'blur'
                    }],
                    staff_id: [{
                        required: true,
                        message: '请选择员工！',
                        trigger: 'blur'
                    }],
                    phone: [{
                        required: true,
                        validator: checkPhone,
                        trigger: 'blur'
                    }],
                    mailbox: [{
                        required: true,
                        validator: checkEMail,
                        trigger: 'blur'
                    }],
                }
            };
        },
        methods: {
            //添加
            Add() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {
                        const url = this.$globals.http + "user/add";
                        axios.post(url, {
                            name: this.from.name,
                            // pwd: this.from.pwd,
                            role_id: this.from.role_id,
                            staff_id: this.from.staff_id,
                            phone: this.from.phone,
                            mailbox: this.from.mailbox,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;

                            if (code === '200') {

                                this.$message.success(data);
                                this.Return();

                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })

                    }
                });
            },
            //修改
            Modify() {
                this.$refs["from"].validate((valid) => {
                    if (valid) {
            
                        const url = this.$globals.http + "user/modify";
                        axios.post(url, {
                            id: this.from.id,
                            name: this.from.name,
                            // pwd: this.from.pwd,
                            role_id: this.from.role_id,
                            staff_id: this.from.staff_id,
                            phone: this.from.phone,
                            mailbox: this.from.mailbox,
                        }).then((response) => {
                            var code = response.data.code;
                            var data = response.data.data;
            
                            if (code === '200') {
            
                                this.$message.success(data);
                                this.Return();
            
                            } else {
                                this.$message.warning("请求失败！请稍后重试");
                            }
                        }).catch((error) => {
                            console.log(error)
                            this.$message.error("服务器未响应！请稍后重试");
                        })
            
                    }
                });
            },
            StaffFind() {
				this.dialogVisibles = true;
            },
            //设置确定
			saveChange(e) {
				this.from.staff_id = e.staff_id;
				this.from.staff_name = e.staff_name;
				this.dialogVisibles = false;
			},
            //返回
            Return() {
                this.trash();
                this.$parent.$parent.Return('add');
            },
            //清除数据
            trash() {
                this.from.mailbox = "";
                this.from.phone = "";
                this.from.staff_id = "";
                this.from.role_id = "";
                // this.from.pwd = "";
                this.from.name = "";
                this.from.id = "";
                this.$refs["from"].resetFields();
            }
        },
        created() {
            //初始化from
            this.from = this.$parent.$parent.from;
        }
    }
</script>

<style>
</style>



// WEBPACK FOOTER //
// User_add.vue?bba2f234